// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"96ca44e0","369":"7e3f648d","616":"8bac27d2","713":"ff906797"}[chunkId] + ".chunk.js";
};